<ng-container *transloco="let t; prefix: 'nav'">
  <aside
    class="hidden md:flex md:flex-col bg-white dark:bg-base-100 px-4 h-screen border-r border-gray-300 dark:border-gray-700 shadow-sm z-50"
    [ngClass]="sideNavIsOpen() ? '!w-64' : 'w-20'"
  >
    <div
      class="flex items-center justify-between pt-3 pb-4"
      [ngClass]="{ 'px-3': sideNavIsOpen() }"
    >
      @if (sideNavIsOpen()) {
        <button
          class="btn p-0 bg-transparent hover:bg-transparent h-fit border-0 w-32 shadow-none dark:hidden"
        >
          <img
            class="w-full"
            src="/assets/logo/qwikopay-hz-logo-dark.svg"
            alt=""
          />
        </button>
        <button
          class="btn p-0 bg-transparent hover:bg-transparent h-fit border-0 w-32 shadow-none hidden dark:!flex"
        >
          <img
            class="w-full"
            src="/assets/logo/qwikopay-hz-logo-light.svg"
            alt=""
          />
        </button>
      } @else {
        <button
          class="btn p-0 bg-transparent hover:bg-transparent h-fit border-0 w-full shadow-none dark:hidden"
        >
          <img class="w-full" src="/assets/logo/qwiko-icon-dark.svg" alt="" />
        </button>
        <button
          class="btn p-0 bg-transparent hover:bg-transparent h-fit border-0 w-full shadow-none hidden dark:!flex"
        >
          <img class="w-full" src="/assets/logo/qwiko-icon-light.svg" alt="" />
        </button>
      }
    </div>
    <div class="flex flex-col mt-4 py-4 gap-y-1">
      <button
        routerLink="/home"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="!bg-primary text-white hover:!opacity-90"
        class="px-3 py-1 flex gap-x-3 items-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded-box"
      >
        @if (sideNavIsOpen()) {
          <i class="fa-solid fa-house text-lg"></i>
          <span class="mt-1 font-normal">{{ t("home") }}</span>
        } @else {
          <div class="flex-1 tooltip tooltip-right" [attr.data-tip]="t('home')">
            <i class="fa-solid fa-house text-lg"></i>
          </div>
        }
      </button>

      <button
        routerLink="/payments"
        routerLinkActive="!bg-primary text-white hover:!opacity-90"
        class="px-3 py-2 flex gap-x-3 items-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded-box"
      >
        @if (sideNavIsOpen()) {
          <i class="fa-solid fa-exchange text-lg"></i>
          <span class="mt-1 ml-1 font-normal">{{ t("payments") }}</span>
        } @else {
          <div
            class="flex-1 tooltip tooltip-right"
            [attr.data-tip]="t('payments')"
          >
            <i class="fa-solid fa-exchange text-xl"></i>
          </div>
        }
      </button>
      <!-- @if (deviceService.isAndroid() || deviceService.isWeb()) {
        <button
          routerLink="/insights"
          routerLinkActive="!bg-primary text-white hover:!opacity-90"
          class="px-3 py-2 hidden gap-x-3 items-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded-box"
        >
          @if (sideNavIsOpen()) {
            <i class="fa-solid fa-chart-mixed text-lg"></i>
            <span class="mt-1 font-normal">{{ t("insights") }}</span>
          } @else {
            <div
              class="flex-1 tooltip tooltip-right"
              [attr.data-tip]="t('insights')"
            >
              <i class="fa-solid fa-chart-mixed text-xl"></i>
            </div>
          }
        </button>
        <button
          routerLink="/reports"
          routerLinkActive="!bg-primary text-white hover:!opacity-90"
          class="px-3 py-2 hidden gap-x-3 items-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded-box"
        >
          @if (sideNavIsOpen()) {
            <i class="fa-solid fa-file-chart-column text-lg mr-1"></i>
            <span class="mt-1 font-normal">{{ t("reports") }}</span>
          } @else {
            <div
              class="flex-1 tooltip tooltip-right"
              [attr.data-tip]="t('reports')"
            >
              <i class="fa-solid fa-file-chart-column text-xl"></i>
            </div>
          }
        </button>
      } -->
      <button
        routerLink="services"
        routerLinkActive="!bg-primary text-white hover:!opacity-90"
        class="px-3 py-2 flex gap-x-3 items-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded-box"
      >
        @if (sideNavIsOpen()) {
          <i class="fa-solid fa-grid-2 text-xl"></i>
          <span class="mt-1 font-normal">{{ t("services") }}</span>
        } @else {
          <div
            class="flex-1 tooltip tooltip-right"
            [attr.data-tip]="t('services')"
          >
            <i class="fa-solid fa-grid-2 text-xl"></i>
          </div>
        }
      </button>
      <!-- <button
        routerLink="services/airtime-data"
        routerLinkActive="!bg-primary text-white hover:!opacity-90"
        class="px-3 py-2 flex gap-x-3 items-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded-box"
      >
        @if (sideNavIsOpen()) {
          <i class="fa-solid fa-mobile-alt text-xl"></i>
          <span class="mt-1 font-normal">Airtime and Data</span>
        } @else {
          <div class="flex-1 tooltip tooltip-right" data-tip="Airtime and Data">
            <i class="fa-solid fa-mobile-alt text-xl"></i>
          </div>
        }
      </button>
      <button
        routerLink="services/bills-utilities"
        routerLinkActive="!bg-primary text-white hover:!opacity-90"
        class="px-3 py-2 flex gap-x-3 items-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded-box"
      >
        @if (sideNavIsOpen()) {
          <i class="fa-solid fa-signal-stream text-xl"></i>
          <span class="mt-1 font-normal">Bills and Utilities</span>
        } @else {
          <div
            class="flex-1 tooltip tooltip-right"
            data-tip="Bills and Utilities"
          >
            <i class="fa-solid fa-signal-stream text-xl"></i>
          </div>
        }
      </button> -->
      <button
        routerLink="/business"
        routerLinkActive="!bg-primary text-white hover:!opacity-90"
        class="px-3 py-2 flex gap-x-3 items-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded-box"
      >
        @if (sideNavIsOpen()) {
          <i class="fa-solid fa-shop text-lg"></i>
          <span class="mt-1 font-normal">{{ t("my_business") }}</span>
        } @else {
          <div
            class="flex-1 tooltip tooltip-right"
            [attr.data-tip]="t('my_business')"
          >
            <i class="fa-solid fa-shop text-xl"></i>
          </div>
        }
      </button>
    </div>
  </aside>
</ng-container>

<!-- <div class="md:hidden flex">
  <a
    href="#"
    class="p-3 flex flex-col gap-x-3 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-box"
  >
    <div class="tooltip tooltip-right" data-tip="Home">
      <i class="fa-solid fa-house text-lg"></i>
    </div>
    <i class="fa-solid fa-house text-lg"></i>
    <span class="mt-2 font-normal">Home</span>
  </a>
  <a
    href="#"
    class="p-3 flex flex-col gap-x-3 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-box"
  >
    <div class="tooltip tooltip-right" data-tip="Payments">
      <i class="fa-solid fa-exchange text-xl"></i>
    </div>
    <i class="fa-solid fa-exchange text-xl"></i>
    <span class="m-0 font-normal">Payments</span></a
  >
  <a
    href="#"
    class="p-3 flex flex-col gap-x-3 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-box"
  >
    <div class="tooltip tooltip-right" data-tip="Airtime and Data">
      <i class="fa-solid fa-mobile-alt text-xl"></i>
    </div>

    <i class="fa-solid fa-mobile-alt text-xl"></i>
    <span class="m-0 font-normal">Airtime and Data</span></a
  >
  <a
    href="#"
    class="p-3 flex flex-col gap-x-3 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-box"
  >
    <div class="tooltip tooltip-right" data-tip="Bills and Utilities">
      <i class="fa-solid fa-signal-stream text-xl"></i>
    </div>
    <i class="fa-solid fa-signal-stream text-xl"></i>
    <span class="m-0 font-normal">Bills and Utilities</span></a
  >
  <a
    href="#"
    class="p-3 flex flex-col gap-x-3 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-box"
  >
    <div class="tooltip tooltip-right" data-tip="Settings">
      <i class="fa-solid fa-cog text-xl"></i>
    </div>
    <i class="fa-solid fa-cog text-xl"></i>
    <span class="m-0 font-normal">Settings</span></a
  >
</div> -->
